var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelpOutlinedIcon = function SvgHelpOutlinedIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#313336",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6692 15.04C14.8692 14.7 14.5292 13.71 15.0092 12.99C15.9792 11.55 17.5991 10.5 19.7392 10.5C22.0891 10.5 23.6992 11.57 24.5192 12.91C25.2192 14.06 25.6291 16.21 24.5491 17.81C23.3491 19.58 22.1992 20.12 21.5792 21.26C21.4292 21.53 21.3391 21.75 21.2792 22.2C21.1891 22.93 20.5892 23.5 19.8492 23.5C18.9792 23.5 18.2692 22.75 18.3692 21.88C18.4292 21.37 18.5492 20.84 18.8292 20.34C19.5992 18.95 21.0791 18.13 21.9391 16.9C22.8491 15.61 22.3392 13.2 19.7592 13.2C18.5892 13.2 17.8291 13.81 17.3591 14.54C17.0092 15.11 16.2792 15.29 15.6692 15.04ZM21.7492 27.5C21.7492 28.6 20.8492 29.5 19.7492 29.5C18.6492 29.5 17.7492 28.6 17.7492 27.5C17.7492 26.4 18.6492 25.5 19.7492 25.5C20.8492 25.5 21.7492 26.4 21.7492 27.5Z",
    fill: "#313336"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelpOutlinedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "help-outlined-icon.80e153bdd6329b95ffac2ef5bed697a4.svg";